import React, { useRef } from "react";
import { NewsArticle } from "../../data/mockNews.js";
import NewsCard from "./NewsCard.js";

interface NewsCarouselProps {
  articles: NewsArticle[];
  className?: string;
}

const NewsCarousel: React.FC<NewsCarouselProps> = ({ articles, className }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  return (
    <div className={`relative ${className || ""}`}>
      <div
        ref={scrollRef}
        className="scrollbar-hide flex gap-4 overflow-x-auto scroll-smooth pb-4 snap-x snap-mandatory"
      >
        {articles.map((article) => (
          <NewsCard key={article.id} article={article} />
        ))}
      </div>

      <button
        onClick={scrollRight}
        className="absolute right-0 top-1/3 -translate-y-1/2 rounded-full bg-white p-3 shadow-lg hover:bg-gray-100"
        aria-label="Défiler vers la droite"
      >
        <i className="fas fa-chevron-right text-nearblack-500"></i>
      </button>
    </div>
  );
};

export default NewsCarousel;
